import { createResource } from 'react-resource-router';
import { eocUserResource } from '@atlassian/eoc-resources';
import { getWidgetTimeline } from '../../endpoints/widget-timeline';
export const createUserTimelineResource = (checkConsolidationOnRouteDependency, depends) => createResource({
  type: 'userTimelineResource',
  getKey: () => 'userTimelineResource',
  getData: async ({
    dependencies
  }) => {
    const isConsolidated = checkConsolidationOnRouteDependency ? await checkConsolidationOnRouteDependency(dependencies) : true;
    if (!isConsolidated) {
      return null;
    }
    const data = await dependencies[eocUserResource.type].promise;

    // Since depends API types are not exported it's impossible to infer types,
    // thus we have to use casting
    const accountId = data === null || data === void 0 ? void 0 : data.accountId;
    const timezone = data === null || data === void 0 ? void 0 : data.timeZone;
    if (!accountId || !timezone) {
      return null;
    }
    return getWidgetTimeline(accountId);
  },
  isBrowserOnly: true,
  depends: [...(depends ? depends : []), eocUserResource.type]
});